module.exports = __webpack_public_path__ + "static/media/Framing Effect.fac778b5.jpg";